"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
class DownloadCount extends _basic_provider.default {
  async getDownloadCount(_ref) {
    let {
      type,
      id
    } = _ref;
    return await this._callApi({
      method: 'get',
      path: '/update-library-downloads-count',
      queryParams: {
        type,
        id
      },
      errorData: {
        entityType: type,
        entityId: id
      },
      errorName: 'DownloadCountError'
    });
  }
  async updateDownloadCount(_ref2) {
    let {
      type,
      id,
      label,
      count
    } = _ref2;
    return await this._callApi({
      method: 'post',
      path: '/update-library-downloads-count',
      payload: {
        id,
        label,
        type,
        count
      },
      errorData: {
        entityType: type,
        entityId: id,
        entityLabel: label,
        entityCount: count
      },
      errorName: 'DownloadCountError'
    });
  }
}
var _default = DownloadCount;
exports.default = _default;